<template>
  <b-col md="4">
    <b-card class="mb-2">
      <b-tabs>
        <b-tab
          id="tab-right-1"
          title="ดำเนินการ"
        >
          <b-row>

            <b-col
              cols="12"
              class="ml-0"
            >
              <b-row>
                <b-col
                  v-for="(box, index) in optionSendType"
                  :key="index"
                  cols="12"
                  class="mt-1"
                >
                  <b-form-radio
                    :key="index"
                    v-model="selected"
                    :value="box.value"
                  >
                    {{ box.text }}
                  </b-form-radio>

                  {{/* Depth2 ตามการรับผิดชอบบริษัท ตามจำนวนความรับผิดชอบงานปัจจุบัน กำหนดเอง */ }}
                  <b-col v-if="index === 0">
                    <b-col
                      v-for="(box, index) in optionSendOrg"
                      :key="index"
                      cols="12"
                      class="mt-1 pl-3"
                    >
                      <div v-if="index != 2">
                        {{ box.text }}
                      </div>
                      <b-col
                        v-if="index === 2"
                        cols="12"
                      >
                        <b-form-radio
                          :key="index"
                          v-model="selected2"
                          :value="box.value"
                        >
                          {{ box.text }}
                        </b-form-radio>

                        <b-form-select
                          v-model="selectedEmp"
                          :options="selectEmp"
                          class="mt-1"
                        />
                      </b-col>

                      <b-col
                        cols="12"
                        class="pl-2"
                      >

                        <b-form-radio
                          v-for="(m, index) in box.RadioData"
                          :key="index"
                          v-model="selected2"
                          :value="m.value"
                        >
                          {{ m.text }}
                        </b-form-radio>

                      </b-col>

                    </b-col>
                  </b-col>

                  <b-col
                    v-if="index === 1"
                    cols="12"
                    class="pl-2"
                  >
                    <b-form-select
                      v-model="selectedReason"
                      :options="selectReasons"
                      class="mt-1"
                    />
                  </b-col>

                </b-col>
              </b-row>
            </b-col>

            <b-col cols="12 mt-2">
              <b-form-group
                label="ความเห็นเจ้าหน้าที่"
                label-for="offficerComment"
              >
                <b-form-textarea
                  id="offficerComment"
                  placeholder="ความเห็นเจ้าหน้าที่"
                  rows="6"
                />
              </b-form-group>

              <b-form-file
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
              />
            </b-col>

            <b-col
              cols="12"
              class="d-flex justify-content-between mt-2"
            >
              <b-button
                variant="secondary"
                @click="onBackBtnClicked"
              >
                ยกเลิก
              </b-button>

              <b-button
                variant="primary"
                @click="onSubmitBtnCliked"
              >
                บันทึก
              </b-button>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab
          id="tab-right-2"
          title="ประวัติ"
        />
      </b-tabs>
    </b-card>
  </b-col>
</template>

<script>
import {
  BRow,
  BCol,
  BFormTextarea,
  BFormGroup,
  BFormInput,
  BTab,
  BTabs,
  BCard,
  BFormRadioGroup,
  BFormSelect,
  BFormFile,
  BButton,
  BFormRadio,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BFormTextarea,
    BFormGroup,
    BFormInput,
    BTab,
    BTabs,
    BCard,
    BFormRadioGroup,
    BFormSelect,
    BFormFile,
    BButton,
    BFormRadio,
  },
  data() {
    return {
      optionSendType: [
        { text: 'ส่งต่อเจ้าหน้าที่', value: 1 },
        { text: 'รับเรื่องส่งฝ่าย', value: 2 },
      ],
      optionSendOrg: [
        {
          text: 'ตามการรับผิดชอบบริษัท',
          RadioData: [
            {
              text: 'เจ้าหน้าที่ ฮงบันจัง',
              value: 1,
            },
          ],
        },
        {
          text: 'ตามจำนวนความรับผิดชอบงานปัจจุบัน',
          RadioData: [
            {
              text: 'เจ้าหน้าที่ ฮเยจิน (6)',
              value: 2,
            },
            {
              text: 'เจ้าหน้าที่ จีซองฮยอน (8)',
              value: 3,
            },
            {
              text: 'เจ้าหน้าที่ โอจูรี (12)',
              value: 4,
            },
          ],
        }, {
          text: 'กำหนดเอง',
          value: 5,
        },
      ],
      selectReasons: [
        { text: 'ชื่อฝ่าย', value: null },
        { text: '22222', value: 1 },
        { text: '33333', value: 2 },
      ],
      selectEmp: [
        { text: 'เจ้าหน้าที่ A', value: null },
        { text: 'เจ้าหน้าที่ B', value: 1 },
        { text: 'เจ้าหน้าที่ C', value: 2 },
      ],
      selected: 1,
      selected2: null,
      selectSend: 1,
      selectedReason: null,
      selectedEmp: null,
    }
  },
  methods: {
    onSubmitBtnCliked() {
      console.log('selected', this.selected)
      console.log('selectSend', this.selectSend)
      console.log('selected2', this.selected2)

      window.open(
        this.$router.resolve({ name: 'LeaderDeptConfirm' }).href,
        '_self',
      )

      // if (this.selected === 1) {
      //   // go 4-2
      //   console.log("go 4-2");
      //   //window.open(this.$router.resolve({name: 'ConsultForm' }).href, '_self');
      //   //RequestFileManage
      //   window.open(
      //     this.$router.resolve({ name: "RequestFileManage" }).href,
      //     "_self"
      //   );
      // } else if (this.selected === 2) {
      //   // go 3-2
      //   console.log("go 3-2");
      //   //window.open(this.$router.resolve({name: 'RequestForm' }).href, '_self');
      //   //ConsultManage
      //   window.open(
      //     this.$router.resolve({ name: "ConsultManage" }).href,
      //     "_self"
      //   );
      // } else if (this.selected === 3) {
      //   // go 5-2
      //   console.log("go 5-2");
      //   //window.open(this.$router.resolve({name: 'CancelledForm' }).href, '_self');
      //   //CancelledManage
      //   window.open(
      //     this.$router.resolve({ name: "CancelledManage" }).href,
      //     "_self"
      //   );
      // } else if (this.selected === 4) {
      //   // look in selectSend
      //   if (this.selectSend === 1) {
      //     // go 6-1
      //     console.log("go 6-1");
      //     window.open(this.$router.resolve({ name: "Confirm" }).href, "_self");
      //   } else if (this.selectSend === 2) {
      //     // go 7-1
      //     console.log("go 7-1");
      //     window.open(this.$router.resolve({ name: "Confirm2" }).href, "_self");
      //   } else if (this.selectSend === 3) {
      //     // go 8-1
      //     console.log("go 8-1");
      //     window.open(this.$router.resolve({ name: "Forward2" }).href, "_self");
      //   }
      // }
    },
    onBackBtnClicked() {
      const routeData = this.$router.resolve({ name: 'LeaderDept' })
      window.open(routeData.href, '_self')
    },
  },
}
</script>

<style></style>
